import { ContractNature } from "../../../../../autogen/bff-api";
import type { AiMessage } from "../../../../../common/ai/AiDraftModal";

export type DescriptionPromptInput = {
  title: string;
  currentDescription: string;
  contractType?: ContractNature;
  cpvCodes: string[];
  estimatedValueNok?: number | null;
  language: "no" | "en";
};

const CONTRACT_TYPE_GLOSS: Record<ContractNature, string> = {
  [ContractNature.Supplies]: "Supplies (purchase of goods or products)",
  [ContractNature.Services]: "Services",
  [ContractNature.Works]: "Works (building and construction)",
  [ContractNature.Combined]: "Combined (a mix of supplies, services and works)",
};

export const buildDescriptionMessages = ({
  title,
  currentDescription,
  contractType,
  cpvCodes,
  estimatedValueNok,
  language,
}: DescriptionPromptInput): AiMessage[] => {
  const outputLanguage = language === "no" ? "Norwegian (Bokmål)" : "English";
  return [
    {
      role: "SYSTEM",
      content: [
        "You are an assistant for Norwegian public procurement helping a buyer write a procurement's description (beskrivelse).",
        `Write the description in ${outputLanguage}.`,
        "Use Markdown: a short intro paragraph, then optionally subheadings and bullet lists for scope and key requirements.",
        "Cover the purpose and background, what is being procured, and the main requirements at a high level.",
        "Be concise and concrete, but do NOT invent specifics that were not provided — no fabricated dates, budgets, brand names, volumes or legal references.",
        "If a current description is provided, improve and build on it rather than discarding it.",
        "Output only the description itself, with no preamble or closing remarks.",
      ].join(" "),
    },
    {
      role: "USER",
      content: [
        `Title: ${title || "(no title)"}`,
        `Contract type: ${contractType ? CONTRACT_TYPE_GLOSS[contractType] : "(unspecified)"}`,
        `CPV codes: ${cpvCodes.length ? cpvCodes.join(", ") : "(none selected)"}`,
        `Estimated value: ${estimatedValueNok != null ? `${estimatedValueNok} NOK` : "(unspecified)"}`,
        `Current description:\n${currentDescription || "(empty)"}`,
      ].join("\n\n"),
    },
  ];
};
